// form
import { useFormContext, useFieldArray, Controller } from 'react-hook-form';
// @mui
import { Box, Stack, Button } from '@mui/material';
// components
import Iconify from '../../components/Iconify';
import { RHFFileUploadField } from '../../components/hook-form';

const FILE_MAX_LENGTH = 3;


export default function JobPostFiles({ readOnly, openFile }) {
  const { control } = useFormContext();

  const { fields, append, remove, update } = useFieldArray({
    control,
    name: 'files',
    keyName: 'fieldId',
  });

  const handleAdd = () => {
    if (fields.length < FILE_MAX_LENGTH) {
      append({
        name: '',
        file: '',
      });
    }
  };

  const handleRemove = (index) => {
    remove(index);
  };
  
  return (
    <Controller
      name='files'
      control={control}
      render={(props) => (
        <Box sx={{ py: 1 }}>
          <Stack spacing={2} sx={{ mb: fields?.length > 0 ? 2 : 0  }}>
            {fields.map((item, index) => (
              <Stack key={`files[${index}]`} direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems="center" justifyContent="space-between">
                {item.name !== '' && (
                  <Button size="small" sx={{textTransform: 'none'}} startIcon={<Iconify icon="eva:link-2-fill" />} onClick={() => openFile(item)} name={`files[${index}].name`}>
                    {item.name}
                  </Button>
                )}
                {item.name === '' &&(
                  <RHFFileUploadField name={`files[${index}].file`} item={item}/>
                )}
                <Button
                  color="error"
                  disabled={readOnly}
                  onClick={() => handleRemove(index)}
                >
                  삭제
                </Button>
              </Stack>
            ))}
          </Stack>
          
          {fields.length < FILE_MAX_LENGTH &&
            <Button disabled={!(fields.length < FILE_MAX_LENGTH) || readOnly} size="small" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleAdd} sx={{ flexShrink: 0 }}>
              파일 추가하기
            </Button>
          }
        </Box>
    )}
    />
  );
}
